import React, { useEffect, useState } from 'react';

// Auto-rotating hero montage: crossfades between training-session images every ~3s
// with a subtle slow zoom (Ken Burns), giving a "live footage" feel reliably.
export default function HeroSlideshow({ images, interval = 3000 }) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!images || images.length < 2) return;
    const id = setInterval(() => {
      setActive((i) => (i + 1) % images.length);
    }, interval);
    return () => clearInterval(id);
  }, [images, interval]);

  return (
    <div className="relative min-h-[320px] md:min-h-full overflow-hidden bg-[#0E1726]">
      {images.map((src, i) => (
        <img
          key={src}
          src={src}
          alt="Live training session"
          loading={i === 0 ? 'eager' : 'lazy'}
          decoding="async"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms] ease-in-out ${
            i === active ? 'opacity-100 kenburns' : 'opacity-0'
          }`}
        />
      ))}
      {/* subtle gradient for depth */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
      {/* live indicator */}
      <div className="absolute top-4 left-4 flex items-center gap-2 bg-black/45 backdrop-blur-sm rounded-full px-3 py-1.5">
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75 animate-ping" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" />
        </span>
        <span className="text-white text-xs font-semibold tracking-wide">LIVE SESSIONS</span>
      </div>
      {/* progress dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5">
        {images.map((_, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            aria-label={`Show slide ${i + 1}`}
            className={`h-1.5 rounded-full transition-all duration-300 ${i === active ? 'w-6 bg-white' : 'w-1.5 bg-white/50'}`}
          />
        ))}
      </div>
    </div>
  );
}
